import moment from 'moment';
import _ from '@rover/globals/underscore';
import Mustache from '@rover/globals/Mustache';
import Rover from '@rover/globals/Rover';
// WARNING: DF from datetimeInjected is not SSR compatible.
// For newer code, use const DF = getDateTimeFormatMapForLang(<lang>) from '@rover/shared/js/constants/i18n/datetime'
import DF from '@rover/shared/js/constants/i18n/datetime/datetimeInjected';
import RequestableSummaryView from './requestable_summary_view';

export default RequestableSummaryView.extend({
  template: Mustache.template('new_design/account_conversations/conversation'),
  getContextData() {
    const data = RequestableSummaryView.prototype.getContextData.apply(this);

    _.each(['start_date', 'end_date'], prop => {
      data[`${prop}_formatted`] = moment(this.model.get(prop)).format(DF.DATE_WEEK_SHORT);
    });

    data.supportsNonContiguousDates = this.model.supportsNonContiguousDates();
    data.datesList = this.model.datesList(DF.DATE_MED);

    if (this.model.supportsNumUnitsPerDay()) {
      data.numUnitsPerDay = this.model.getPerDaySummary();
    }
    return data;
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/checkout/conversation_view.js